<template>
  <div class="col-md-5 mt-5">
    <div class="px-4 pb-5 pt-4 orange-form rounded-0">
      <form @submit.prevent="login">
        <h5 class="mt-3 mb-4 text-orange text-center">Login</h5>
        <div class="text-center">
          <p v-if="login_error" class="text-danger">Authentication failed!</p>
          <p v-if="account_blocked" class="text-danger">
            Your account is under review, please contact support for more
            information.
          </p>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="input_height_default form-control"
            aria-describedby="emailHelp"
            placeholder="Email or Phone number"
            v-model="form.email"
            :class="{ 'is-invalid': form.errors.has('email') }"
          />
          <has-error :form="form" field="email" />
        </div>

        <div class="form-group">
          <input
            type="password"
            class="input_height_default form-control"
            placeholder="Password"
            v-model="form.password"
            :class="{ 'is-invalid': form.errors.has('password') }"
          />
          <has-error :form="form" field="password" />
        </div>
        <div class="button_wrapper text-center mt-5">
          <button
            type="submit"
            class="btn orange_button py-2 btn-block text-white"
          >
            Login to your account
          </button>

          <p class="text-right small mt-3">
            <router-link :to="{ name: 'forgot-password' }" class="text-orange">
              Forgot Password?
            </router-link>
          </p>
        </div>
      </form>
    </div>

    <p class="text-center small mt-3">
      <span class="text-white">Dont Have An Account?&nbsp;</span>
      <router-link :to="{ name: 'register' }" class="text-orange">
        Sign Up
      </router-link>
    </p>
  </div>
</template>

<script>
import Form from "vform";
import { LOGIN } from "@/Endpoints/auth";
import { networkError, toggleFormLoading } from "@/Helpers/general";

export default {
  layout: "default",
  name: "login",
  middleware: "guest",
  data: () => ({
    login_error: false,
    account_blocked: false,
    form: new Form({
      email: "",
      password: ""
    })
  }),
  methods: {
    async login() {
      toggleFormLoading(this);
      try {
        this.login_error = false;
        this.account_blocked = false;
        const { data } = await this.form.post(LOGIN);

        toggleFormLoading(this);

        this.$store.dispatch("auth/saveToken", {
          token: data.access_token
        });

        this.$store.dispatch("auth/updateUser", {
          user: data.user
        });

        this.$store.dispatch("loan/saveLoan", {
          loan: data.loan
        });

        this.$router.push({ name: "dashboard" });
      } catch (error) {
        toggleFormLoading(this);
        if (
          typeof error.response === "undefined" ||
          !error.response.status === 422
        ) {
          networkError();
        }

        if (error.response.status === 401) {
          this.login_error = true;
        }
        if (error.response.status === 403) {
          this.account_blocked = true;
        }
      }
    }
  }
};
</script>
